import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import JoinClient from "@/pages/JoinClient";
import BecomeNT from "@/pages/BecomeNT";
import About from "@/pages/About";
import PaymentReturn from "@/pages/PaymentReturn";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import NTDashboard from "@/pages/nt/NTDashboard";
import ClientPortal from "@/pages/client/ClientPortal";
import AdminCMS from "@/pages/admin/AdminCMS";
import BetaSignup from "@/pages/BetaSignup";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import TestPayment from "@/pages/TestPayment";
import FAQ from "@/pages/FAQ";
import Sport from "@/pages/Sport";
import InnerCircle from "./pages/InnerCircle";
import Promo from "./pages/Promo";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/join" element={<JoinClient />} />
      <Route path="/beta" element={<BetaSignup />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/test-payment" element={<TestPayment />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/therapists" element={<BecomeNT />} />
      <Route path="/about" element={<About />} />
      <Route path="/sport" element={<Sport />} />
      <Route path="/inner-circle" element={<InnerCircle />} />
      <Route path="/promo" element={<Promo />} />
      <Route path="/payment-return" element={<PaymentReturn />} />
      <Route path="/dashboard" element={<ProtectedRoute roles={["nutrition_therapist"]}><NTDashboard /></ProtectedRoute>} />
      <Route path="/portal" element={<ProtectedRoute roles={["client", "admin", "nutrition_therapist"]}><ClientPortal /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminCMS /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
